export const isLoggedInWithWrongIdentityProvider = (user = {}) => {
  const idTokenPayload = user?.signInUserSession?.idToken?.payload;
  const identityProvider = idTokenPayload?.identities?.[0]?.providerName;

  if (
    process.env.FEDERATED_AUTH_PROVIDER &&
    identityProvider !== process.env.FEDERATED_AUTH_PROVIDER
  ) {
    return true;
  }

  return false;
};
